import React from 'react';
import MaxWidth from '../../Layout/MaxWidth';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image';
import { LinkEvaluator } from '../../../utils/LinkEvaluator';
import { theme } from '../../Theme';
import { HtmlOnImage, TitleOnImage } from './StartPageCardSlider';

const StartPageGridMaxWidth = styled(MaxWidth)``;

const StartPageGridWrapper = styled('div')`
  display: grid;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  margin: 0 auto;
  grid-template-columns: repeat(4, 1fr);

  ${theme.below.md} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StartPageLinkGrid = ({ children }) => {
  return (
    <StartPageGridMaxWidth>
      <StartPageGridWrapper>{children}</StartPageGridWrapper>
    </StartPageGridMaxWidth>
  );
};

const StartPageLinkGridItemWrapper = styled('div')`
  aspect-ratio: 1/1;
  overflow: hidden;
  background-color: #f0f0f0;
  position: relative;
  flex: 1;
  border-radius: 10px;

  .html-on-image {
    position: absolute;
    bottom: 50%;
    transform: translateY(50%);
    left: 10px;
    right: 10px;
    top: auto;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: #fff;
  }
`;

export const StartPageLinkGridItem = ({ image, html, textShadow, link }) => {
  return (
    <StartPageLinkGridItemWrapper className="start-page-grid-item">
      <LinkEvaluator link={link}>
        <Image
          src={image?.value}
          alt={''}
          cover={true}
          sizes={[1 / 2, 1 / 2, 1 / 4, 1 / 6]}
        />

        <HtmlOnImage html={html} shadow={textShadow} />
      </LinkEvaluator>
    </StartPageLinkGridItemWrapper>
  );
};
